"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatPercent = useFormatPercent;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted as the percentage.
 * @see {@link formatPercent} for more information.
 *
 * @param value Numeric value to format
 * @param options Additional formatting options
 * @returns `value` formatted as the percentage
 * @example
  // basic usage
  useFormatPercent(1234.567);

  // specify number of decimals to display
  useFormatPercent(1234.567, { decimals: Decimals.One })
 */
function useFormatPercent(value, options) {
  const {
    culture
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatPercent)(value, culture, options);
}
